<script>
export default {
  name: 'ui-calendar-icon',
}
</script>

<template>
  <svg class="t-events-buttons__svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path d="M18.123 5.03906H16.6406V4.26562C16.6406 3.98087 16.4098 3.75 16.125 3.75C15.8402 3.75 15.6094 3.98087 15.6094 4.26562V5.03906H8.39062V4.26562C8.39062 3.98087 8.15979 3.75 7.875 3.75C7.59021 3.75 7.35938 3.98087 7.35938 4.26562V5.03906H5.87695C4.70413 5.03906 3.75 5.99319 3.75 7.16602V18.123C3.75 19.2959 4.70413 20.25 5.87695 20.25H18.123C19.2959 20.25 20.25 19.2959 20.25 18.123V7.16602C20.25 5.99319 19.2959 5.03906 18.123 5.03906ZM5.87695 6.07031H7.35938V6.58594C7.35938 6.87069 7.59021 7.10156 7.875 7.10156C8.15979 7.10156 8.39062 6.87069 8.39062 6.58594V6.07031H15.6094V6.58594C15.6094 6.87069 15.8402 7.10156 16.125 7.10156C16.4098 7.10156 16.6406 6.87069 16.6406 6.58594V6.07031H18.123C18.7272 6.07031 19.2188 6.56183 19.2188 7.16602V8.39062H4.78125V7.16602C4.78125 6.56183 5.27277 6.07031 5.87695 6.07031ZM18.123 19.2188H5.87695C5.27277 19.2188 4.78125 18.7272 4.78125 18.123V9.42188H19.2188V18.123C19.2188 18.7272 18.7272 19.2188 18.123 19.2188Z" fill="#929292"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16.5" height="16.5" fill="white" transform="translate(3.75 3.75)"/>
      </clipPath>
    </defs>
  </svg>
</template>


// WEBPACK FOOTER //
// src/templates/pages/events/components/icons/calendar.vue